import { Sound } from "../sound/sound.js";
/**
 * Lap info
 */
export class LapInfo {
  static PREFIX = "Lap ";
  static SEPARATOR = " / ";
  /**
   * Construct lap info
   * @param {HTMLElement} element The element to display lap info in
   * @param {Racer} racer The racer to track
   * @param {number} length The length of one lap
   * @param {number} laps The total number of laps
   */
  constructor(element, racer, length, laps) {
    this.element = element;
    this.racer = racer;
    this.length = length;
    this.laps = laps;
    this.audio = new Sound();

    this.counter = 0;
    this.firstcounter = 1;
    this.firstplayed = true;

    this.update();
  }

  /**
   * Update the state
   */
  update(soundEffects) {
    if (this.racer.moved !== -1) {
      // const laps = Math.min(this.laps, 1 + Math.floor(this.racer.moved / this.length)).toString();
      // this.element.innerText = LapInfo.PREFIX + laps + LapInfo.SEPARATOR + this.laps.toString();

      this.currentlap = Math.min(
        this.laps,
        1 + Math.floor(this.racer.moved / this.length)
      ).toString();
      this.element.innerText =
        LapInfo.PREFIX +
        this.currentlap +
        LapInfo.SEPARATOR +
        this.laps.toString();

      let show_lap_banner = "N";
      let lapbanner = "LAP " + this.currentlap;
      if (this.currentlap !== this.counter && this.currentlap < this.laps) {
        this.counter = this.currentlap;
        if (soundEffects) {
          this.audio.setVolume("lap_sound", "0.5");
          this.audio.playSound("lap_sound");
        }
        show_lap_banner = "Y";
      }

      if (this.currentlap == this.laps && this.counter < this.currentlap) {
        this.counter = this.currentlap;
        if (soundEffects) {
          this.audio.setVolume("final_lap", "0.5");
          this.audio.playSound("final_lap");
        }
        lapbanner = "FINAL LAP";
        show_lap_banner = "Y";
      }

      // Show Lap Banner
      if (show_lap_banner == "Y" && this.currentlap > 1) {
        window.$("#racerbanner").fadeIn();
        var finaltxt =
          '<span style="font-size: 70px;background: rgb(0,0,0,.3);color: white;border-radius: 10px;padding:10px 20px;border:1px solid white;">';
        finaltxt = finaltxt + lapbanner + "</span>";
        window.$("#racerbanner").html(finaltxt);
        setTimeout(function () {
          window.$("#racerbanner").fadeOut(1000);
        }, 3000);
      }

      //turn off loop after the race finishes
    }
  }
}
